import React, { useEffect } from "react";
import Sidebar from "./layout/sidebar/Sidebar";
import Header from "./layout/header/Header";
import { Routes, Route, useLocation } from "react-router";
import Dashboard from "./pages/dashboard/Dashboard";
import Learners from "./pages/learners/Learners";
//import Courses from "./pages/courses-beta/Courses";
import Courses from "./pages/courses/Courses";
import RewardRoutes from "./pages/rewards/RewardRoutes";
//import LearningPath from "./pages/learning-path-beta/PathRoutes";
//import Module from "./pages/module-beta/Module";
import Analytics from "./pages/analytics/Analytics";
import UserManagement from "./pages/user-management/UserManagement";
import BillingRoutes from "./pages/billing/site-admin/BillingRoutes";
import ClientBillingRoutes from "./pages/billing/client-admin/BillingRoutes";
import ActionPlanRoutes from "./pages/action-plan/ActionPlanRoute";
import CertificateRoutes from "./pages/certificate-editor/CertificateRoutes";
import Navbar from "./layout/header/Navbar";
import Clients from "./pages/clients/Client";
import Modules from "./pages/modules/Modules";
import Cohorts from "./pages/cohorts/Cohorts";
import LearningPath from "./pages/learningPath/LearningPath";
import RolesPrivilegesRoutes from "./pages/roles-and-priviledges/RolesPrivilegesRoutes";
// import AdminMangementRoute from "./pages/admin-management/AdminMangementRoute";
import EmailEditorRoutes from "./pages/email/EmailEditorRoutes";
import ZoomRoutes from "./pages/zoom/ZoomRoutes";
import SettingsRoutes from "./pages/settings/SettingsRoutes";
import Feedback from "./pages/feedback/Feedback";
import ContentRoutes from "./pages/content-libary/ContentRoutes";
import ReportRoute from "./pages/report/ReportRoute";
import AdminMangementRoute from "./pages/admin-management/AdminMangementRoute";
import { set } from 'date-fns';
import NotificationRoutes from "./pages/notifications/NotificationRoutes"
import AuditLogRoutes from "./pages/audit-log/AuditLogRoutes";
import PrivilegeGate from "../Auth/PrivilegeGate";

const AdminRoutes = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const accountType = user?.role?.slug;
  const isClientAdmin = accountType === "client-admin";
  const org = JSON.parse(sessionStorage.getItem('user'))
  const themes = sessionStorage.getItem('account-customization')
  const [isReportEditorRoutes, setIsReportEditorRoutes] = React.useState(false);
  const location = useLocation();

  useEffect( () => {
    if(location.pathname === '/admin/report/create' || location.pathname === '/admin/report/edit') {
      setIsReportEditorRoutes(true)
    } else setIsReportEditorRoutes(false)
    }, [location.pathname])

  return (
    <div className="flex justify-between overflow-y-hidden">
      { !isReportEditorRoutes &&
        <div className="w-[250px]">
        <Sidebar />
      </div>}
      <div className={`text-gray-900 ${
        isReportEditorRoutes ? 'w-[100%]' : 'w-[calc(100%-250px)]'
      }`}>
        <section 
          className={`h-[calc(100vh)] ${isReportEditorRoutes ? 'px-1' : 'px-5'} pt-2 admin-container-panel overflow-y-auto`}
          style={{
            backgroundColor : themes ? JSON.parse(themes)?.bodyColor :
            org?.orgAppearance?.bodyBackgroundColour || "#F2F4F7"
          }}
        >
          <Navbar />
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/clients/*"
              element={
                <PrivilegeGate privileges={["viewAClient"]}>
                  <Clients />
                </PrivilegeGate>
              }
            />
            <Route
              path="/learners/*"
              element={
                <PrivilegeGate
                  privileges={[
                    "viewACohort",
                    "viewATeam",
                    "viewAReward",
                    "viewAnActionPlan",
                    "viewAQuiz",
                    "viewAnalytics",
                  ]}
                >
                  <Learners />
                </PrivilegeGate>
              }
            />
            <Route
              path="/course/*"
              element={
                <PrivilegeGate privileges={["viewACourse"]}>
                  <Courses />
                </PrivilegeGate>
              }
            />
            <Route
              path="/courses/module/*"
              element={
                <PrivilegeGate privileges={["viewAModule"]}>
                  <Modules />
                </PrivilegeGate>
              }
            />
            <Route
              path="/courses/analytics"
              element={
                <PrivilegeGate privileges={["viewAnalytics"]}>
                  <Analytics />
                </PrivilegeGate>
              }
            />
            <Route
              path="/cohort/*"
              element={
                <PrivilegeGate privileges={["viewACohort"]}>
                  <Cohorts />
                </PrivilegeGate>
              }
            />
            <Route
              path="/learning-path/*"
              element={
                <PrivilegeGate privileges={["viewALearningPath"]}>
                  <LearningPath />
                </PrivilegeGate>
              }
            />
            <Route
              path="/report/*"
              element={
                <PrivilegeGate privileges={["viewReport"]}>
                  <ReportRoute />
                </PrivilegeGate>
              }
            />
            <Route
              path="/user-management/*"
              element={
                <PrivilegeGate privileges={["viewARole"]}>
                  <UserManagement />
                </PrivilegeGate>
              }
            />
            <Route
              path="/billing/*"
              element={
                <PrivilegeGate
                  privileges={[
                    "viewBillingSummary",
                    "viewInvoices",
                    "viewDiscounts",
                    "viewCreditCodes",
                  ]}
                >
                  {isClientAdmin ? <ClientBillingRoutes /> : <BillingRoutes />}
                </PrivilegeGate>
              }
            />
            <Route
              path="/rewards/*"
              element={
                <PrivilegeGate privileges={["viewAReward"]}>
                  <RewardRoutes />
                </PrivilegeGate>
              }
            />
            <Route
              path="/zoom/*"
              element={
                <PrivilegeGate privileges={["viewMeetings"]}>
                  <ZoomRoutes />
                </PrivilegeGate>
              }
            />
            {/* <Route path="/settings/*" element={<SettingRoutes />} /> */}
            <Route
              path="/action-plan/*"
              element={
                <PrivilegeGate privileges={["viewAnActionPlan"]}>
                  <ActionPlanRoutes />
                </PrivilegeGate>
              }
            />
            {/* Individual Settings tabs are gated inside SettingsLayout/SettingsRoutes */}
            <Route path="/settings/*" element={<SettingsRoutes />} />
            <Route
              path="/email/*"
              element={
                <PrivilegeGate privileges={["viewEmailTemplates"]}>
                  <EmailEditorRoutes />
                </PrivilegeGate>
              }
            />
            <Route
              path="/certificate/*"
              element={
                <PrivilegeGate privileges={["viewCertificates"]}>
                  <CertificateRoutes />
                </PrivilegeGate>
              }
            />
            <Route
              path="/roles-and-privileges/*"
              element={
                <PrivilegeGate privileges={["viewARole"]}>
                  <RolesPrivilegesRoutes />
                </PrivilegeGate>
              }
            />
            <Route
              path="/admins/*"
              element={
                <PrivilegeGate privileges={["viewAdmins"]}>
                  <AdminMangementRoute />
                </PrivilegeGate>
              }
            />
            <Route
              path='/feedback/*'
              element={
                <PrivilegeGate privileges={["viewFeedback"]}>
                  <Feedback />
                </PrivilegeGate>
              }
            />
            <Route
              path='/content-library/*'
              element={
                <PrivilegeGate privileges={["viewContent"]}>
                  <ContentRoutes />
                </PrivilegeGate>
              }
            />
            <Route
              path='/notifications/*'
              element={
                <PrivilegeGate privileges={["viewNotifications"]}>
                  <NotificationRoutes />
                </PrivilegeGate>
              }
            />
            <Route
              path='/audit-log/*'
              element={
                <PrivilegeGate privileges={["viewAuditLog"]}>
                  <AuditLogRoutes />
                </PrivilegeGate>
              }
            />
          </Routes>
        </section>
      </div>
    </div>
  );
};

export default AdminRoutes;
